
const inputStyle = { width: '50%',fontSize:'14px' };

const DocumentUploads = ({ formData,errorData,uploadState, handleChange, handleFileChange }) => {
  return (
    <div className="card-body">
      <div className="mb-0">
        <label  htmlFor="websiteUrl" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Company Website URL</label>
        <input
          type="url"
          className="form-control"
          id="websiteUrl"
          name="websiteUrl"
          value={formData.websiteUrl}
          onChange={handleChange}
          // placeholder="https://example.com"
          style={inputStyle}
        />
      
<label style={{color:"red"}} htmlFor="">{errorData.websiteUrl}</label>
      </div>

      {uploadState.includes("panCard") && (
      <div className="mb-0">
        <label htmlFor="panCard" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Company PAN Card <span style={{color:'red'}}>*</span> </label>
        <input
          type="file"
          className="form-control"
          id="panCard"
          name="panCard"
          onChange={handleFileChange}
          required
          style={inputStyle}
        />
      <label style={{color:"red"}} htmlFor="">{errorData.panCard}</label>
      </div>)
      }
      {uploadState.includes("gstinCertificate") && (
        <div className="mb-1">
          <label htmlFor="gstinCertificate" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Company GSTIN Certificate {!formData.isUnregisteredDealer && <span style={{color:'red'}}>*</span>}  </label>
          <input
            type="file"
            className="form-control"
            id="gstinCertificate"
            name="gstinCertificate"
            onChange={handleFileChange}
            required={!formData.gstin}
            style={inputStyle}
          />
        <label style={{color:"red"}} htmlFor="">{errorData.gstinCertificate}</label>
        </div>

      )}

     {uploadState.includes("incorporationCertificate") &&
     ( <div className="mb-1">
        <label htmlFor="incorporationCertificate" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Company Certificate of Incorporation <span style={{color:'red'}}>*</span> </label>
        <input
          type="file"
          className="form-control"
          id="incorporationCertificate"
          name="incorporationCertificate"
          onChange={handleFileChange}
          required
          style={inputStyle}
        />
<label style={{color:"red"}} htmlFor="">{errorData.incorporationCertificate}</label>
      </div>)}

      {uploadState.includes('authorizationLetter') && (<div className="mb-1">
        <label htmlFor="authorizationLetter" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Company Authorization Letter for Account User <span style={{color:'red'}}>*</span> </label>
        <input
          type="file"
          className="form-control"
          id="authorizationLetter"
          name="authorizationLetter"
          onChange={handleFileChange}
          required
          style={inputStyle}

        />
<label style={{color:"red"}} htmlFor="">{errorData.authorizationLetter}</label>
      </div>
      )}
      {uploadState.includes("msmeCertificate") && (<div className="mb-1">
        <label htmlFor="msmeCertificate" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Company MSME Certificate <span style={{color:'red'}}>*</span> </label>
        <input
          type="file"
          className="form-control"
          id="msmeCertificate"
          name="msmeCertificate"
          onChange={handleFileChange}
          required
          style={inputStyle}
        />
<label style={{color:"red"}} htmlFor="">{errorData.msmeCertificate}</label>
      </div>)}
      {uploadState.includes("aadharCard") && (<div className="mb-1">
        <label htmlFor="aadharCard" style={{fontWeight:"bold",marginBottom:"0px"}} className="form-label">Upload Aadhar Card <span style={{color:'red'}}>*</span> </label>
        <input
          type="file"
          className="form-control"
          id="aadharCard"
          name="aadharCard"
          onChange={handleFileChange}
          required
          style={inputStyle}
        />
<label style={{color:"red"}} htmlFor="">{errorData.aadharCard}</label>
      </div>)}
    </div>
  );
};

export default DocumentUploads;
